import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { FormGroup, Label, Progress } from "reactstrap";
import { timeDifference } from "utils/timeDifference";
import { ImageUpload, FormEntry, FormSelect } from "components";
import useProgressBar from "components/ProgressBar/useProgressBar";
import { encodeImageFileAsURL } from "utils/fileToBase64";
import { removeEmptyStringFields } from "utils/objectCleaning";
import apiService from "services/api";
import { useNotificationContext } from "contexts";
import { daysMapper, leaveTypes, amPmOptions } from "./constants";
import { useQuery } from "react-query";
import { create } from "lodash";

const leaveInitialState = {
    staffId: undefined,
    date: undefined,
    type: "RO",
    period: "HD",
    startTime: undefined,
    endTime: undefined,
    reason: undefined,
    proofImg: undefined,
    isOt: false,
};

const SudoROApplicationPage = () => {
    const history = useHistory();

    const { createNotification } = useNotificationContext();

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        formState: { errors },
        setError,
        clearErrors,
    } = useForm({ mode: "onChange", defaultValues: leaveInitialState });

    const { data: staffList } = useQuery("staffList", () =>
        apiService.staff
            .get(undefined, { show_deactivated: true })
            .then((staffs) => {
                createNotification({
                    type: "success",
                    message: "Staff list retrieved",
                });
                return staffs.filter(
                    (staff) => staff.active && staff.employeeType === "FT"
                );
            })
            .catch((error) => {
                createNotification({
                    type: "danger",
                    message: "Unable to retrieve staff list",
                });
            })
    );

    const onSubmit = async (data) => {
        clearErrors();
        const formData = removeEmptyStringFields(data);

        apiService.leave
            .sudoRO({ ...formData })
            .then(() => {
                createNotification({
                    type: "success",
                    message: "Leave successfully submitted",
                });
                history.push("/leave/me");
            })
            .catch((error) => {
                createNotification({ type: "danger", message: error.message });
                console.log(error.message);
            });
    };

    const selectedPeriod = watch("period");

    return (
        <div className="content">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex justify-content-center">
                    <div className="w-75">
                        <h5 className="text-center mb-4">
                            Superadmin RO Application
                        </h5>

                        {staffList && (
                            <FormSelect
                                formLabel="Staff"
                                register={register}
                                name="staffId"
                                options={staffList.map((staff) => ({
                                    value: staff.id,
                                    label: staff.fullName,
                                }))}
                                error={errors.staffId}
                                required={true}
                            />
                        )}

                        <FormEntry
                            formLabel="Leave Date"
                            type="date"
                            register={register}
                            name="date"
                            error={errors.date}
                            required={true}
                        />

                        <FormSelect
                            formLabel="Leave Period"
                            register={register}
                            name="period"
                            options={daysMapper[watch("type") || "RO"]}
                            error={errors.period}
                            required={true}
                        />
                        {selectedPeriod === "HD" && (
                            <div>
                                <FormSelect
                                    formLabel={`Leave AM/PM`}
                                    register={register}
                                    name="amPm"
                                    options={amPmOptions}
                                    error={errors.period}
                                    required={true}
                                />
                            </div>
                        )}
                        <button
                            className="btn btn-primary float-right"
                            type="submit"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default SudoROApplicationPage;
